import { CvpSettings } from "../settings/CvpSettings";
import { getCurrentPathBinding } from "../settings/pathBinding";
import { settings } from "../settings/settings";
import { routerStore } from "./WSRouter";
import { getStartPage } from "./getStartPage";
import { CVPSearchParams, queryStringStore } from "./wsQueryStringStore";

/**
 * The path the app internally uses, not necessarily the same as the browser path.
 */
export function getCurrentPath() {
  const iframe_startPage = getStartPage();
  const cvpage = queryStringStore.qs[CVPSearchParams.cvpage];
  const p = routerStore.location.pathname;

  return _evaluatePath(
    settings.get(),
    !!window.cvpSandboxType,
    routerStore.hostUrl,
    window.cvpEmbedType,
    iframe_startPage,
    cvpage,
    p
  );
}

/**
 * The path the app internally would use, not necessarily the same as the browser path.
 */
export function evaluatePath(url: string) {
  const iframe_startPage = getStartPage();

  const hasProtocol = url.startsWith("http://") || url.startsWith("https://");
  const _url = new URL(hasProtocol ? url : "tempprotocol://" + url);

  const cvpage = _url.searchParams.get(CVPSearchParams.cvpage);
  const p = _url.pathname;

  return _evaluatePath(
    settings.get(),
    !!window.cvpSandboxType,
    routerStore.hostUrl,
    window.cvpEmbedType,
    iframe_startPage,
    cvpage,
    p
  );
}

export function _evaluatePath(
  settings: CvpSettings,
  isEmbedDemo: boolean,
  hostUrl: string | undefined,
  cvpEmbedType: string | undefined,
  iframe_startPage: string,
  cvpage: string,
  pathname: string
) {
  if (cvpage) {
    return cvpage;
  }

  const currentPathBinding = getCurrentPathBinding(
    hostUrl,
    settings,
    isEmbedDemo
  );

  if (currentPathBinding) {
    return currentPathBinding.pages[0];
  }

  if (cvpEmbedType) {
    return iframe_startPage;
  }

  const p = pathname;

  if (!p || p === "/") {
    return iframe_startPage;
  }

  return p;
}
